"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformPartnerIntegrationModelLifecycleEventStatus = exports.InformPartnerIntegrationModelLifecycleEventStep = void 0;
var InformPartnerIntegrationModelLifecycleEventStep;
(function (InformPartnerIntegrationModelLifecycleEventStep) {
    InformPartnerIntegrationModelLifecycleEventStep["Fetch"] = "Fetch";
    InformPartnerIntegrationModelLifecycleEventStep["Upsert"] = "Upsert";
})(InformPartnerIntegrationModelLifecycleEventStep = exports.InformPartnerIntegrationModelLifecycleEventStep || (exports.InformPartnerIntegrationModelLifecycleEventStep = {}));
var InformPartnerIntegrationModelLifecycleEventStatus;
(function (InformPartnerIntegrationModelLifecycleEventStatus) {
    InformPartnerIntegrationModelLifecycleEventStatus["Failed"] = "Failed";
    InformPartnerIntegrationModelLifecycleEventStatus["Completed"] = "Completed";
    InformPartnerIntegrationModelLifecycleEventStatus["Partial_Failure"] = "Partial Failure";
})(InformPartnerIntegrationModelLifecycleEventStatus = exports.InformPartnerIntegrationModelLifecycleEventStatus || (exports.InformPartnerIntegrationModelLifecycleEventStatus = {}));
//# sourceMappingURL=InformPartnerIntegrationModelLifecycleEventJobInput.js.map